import { render, staticRenderFns } from "./CostTypeTable.vue?vue&type=template&id=66963abc&"
import script from "./CostTypeTable.vue?vue&type=script&lang=js&"
export * from "./CostTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./CostTypeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports